import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Cookie } from 'ng2-cookies';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'environment';
import { AuthUserService } from '../../service/auth-user-service';
import { AuthService } from '@gsa-sam/shared';

export const LoggedInGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Promise<boolean> | boolean | Observable<boolean> => {
  const auth: AuthService = inject(AuthService);
  const authUserService: AuthUserService = inject(AuthUserService);

  console.log('LoggedInGuard canActivate()');
  if (environment.ENV === 'development') {
    setTimeout(() => {
      getUserDetailsFromSession().subscribe();
    }, 100);
    return true;
  }

  if (!authUserService.isLoggedIn()) {
    authUserService.signInUser(false, state.url);
    return false;
  }

  // Get session email
  return getUserDetailsFromSession().pipe(
    map(() => {
      // Check if session user is using a temp profile
      // If so, delete session cookie, trigger sign in, and prevent user from viewing guarded pages
      if (authUserService.getIsTempProfile()) {
        Cookie.delete('SESSION');
        authUserService.signInUser(false, state.url);
        return false;
      }

      // Session email is not temporary, allow user to proceed
      return true;
    }),
  );
  // if (!Cookie.check('SESSION')) {
  //   return false;
  // }

  // return auth.checkSession().pipe(
  //   map((_) => true),
  //   catchError((_) => of(false))
  // );

  function getUserDetailsFromSession() {
    return auth.checkSession().pipe(
      tap((response) => {
        authUserService.setUser(response);
        authUserService.setUserId(response['email']);
        authUserService.setIsTempProfile(response['isTempProfile']);
      }),
    );
  }
};

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  console.log('LoggedInGuard canActivateChild()');
  return LoggedInGuard(route, state);
};
